import { SearchOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import classes from './NotificationNoReports.module.scss';

export const NotificationNoReports = () => {
  return (
    <div className={classes.noReportsWrapper}>
      <SearchOutlined className={classes.searchIcon} />
      <Typography.Title level={4} className={classes.notificationText}>
        Sorry, we can't find records on your request
      </Typography.Title>
      <Typography.Text type="secondary" className={classes.notificationText}>
        Try to change filter criteria
      </Typography.Text>
    </div>
  );
};
